
import { useStore } from "@/store";
import { SysActionTypes } from "@/store/sys/action-types";
import { OptionsDataType } from "@/const/indexedDB";
import { Equipment, EquipDataType } from "@/const/equips/equipmentType";
import { computed, reactive, ref } from "vue";
const store = useStore();
export default {
  name: "GoodItem",
  props: ["item", "choseList"],
  emits: {
    choseItem: (payload: any) => {
      return payload;
    }
  },
  setup(props: any, context: any) {
    const equipDataInit: EquipDataType = {
      flag: false
    };
    const equipData = reactive(equipDataInit);
    const grade = ref(0);
    const goodItem = ref();
    const getEquipDetail = async (row: PackItem) => {
      const params: OptionsDataType = {
        index: row.id
      };
      const data: Equipment = await store.dispatch(
        SysActionTypes.SYS_GET_EQUIP,
        params
      );
      if (data) {
        data.id = row.id;
        equipData.value = data;
        equipData.flag = true;
        grade.value = data.grade;
      }
    };
    // 如果是装备则获取详情
    if (props.item.type === "equipment") {
      getEquipDetail(props.item);
    }
    const handleChose = (item: PackItem) => {
      // eslint-disable-next-line vue/custom-event-name-casing
      context.emit("choseItem", { id: item.id, ...equipData.value });
    };
    const choseListIds = computed(() => {
      return props.choseList.map(({ id }: { id: number }) => id);
    });
    return {
      goodItem,
      equipData,
      grade,
      handleChose,
      choseListIds
    };
  }
};
